<template>
  <div class="auth-wrapper">
    <div class="auth-card">
      <h1>Привет!</br>Я Лена - виртуальный ассистент fitness365!</h1>
      <p class="subtitle"><img src="@/assets/auth_logo.png"></img></p>
      <p class="subtitle-text">Мы просим e-mail, чтобы сохранять историю Ваших обращений и быстрее помогать. Указывая e-mail, Вы соглашаетесь на его обработку.</p>
      <input
        v-model="username"
        placeholder="Ваш email"
        @keyup.enter="submit"
        class="auth-input"
      />
      <input
        v-if="isAdminUsername"
        v-model="password"
        type="password"
        placeholder="Пароль администратора"
        @keyup.enter="submit"
        class="auth-input"
      />
      <div class="button-row">
        <button @click="skip" class="skip-button">Пропустить</button>
        <button @click="submit" class="auth-button">Войти</button>
      </div>
      <p v-if="error" class="error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import { ALLOWED_USERNAMES } from './constants.js';
import { v4 as uuidv4 } from 'uuid';
import { adminApi } from './api/admin-api';

export default {
  name: 'UserAuth',
  data() {
    return {
      username: '',
      password: '',
      error: ''
    }
  },
  computed: {
    isAdminUsername() {
      return this.username.trim().toLowerCase() === 'admin';
    }
  },
  methods: {
    async submit() {
      const trimmed = this.username.trim().toLowerCase();

      if (trimmed === 'admin') {
        try {
          await adminApi.post('/login', { password: this.password });
          localStorage.setItem('USER_NAME', 'admin');
          localStorage.setItem('ADMIN_PASSWORD', this.password);
          this.error = '';
          this.$emit('authorized');
        } catch (e) {
          this.error = 'Неверный пароль администратора.';
        }
        return;
      }

      if (ALLOWED_USERNAMES.includes(trimmed) || this.validateEmail(trimmed)) {
        localStorage.setItem('USER_NAME', trimmed);
        this.$emit('authorized');
      } else {
        this.error = 'Введен некорректный e-mail. ';
      }
    },
    skip() {
      localStorage.setItem('USER_NAME', `guest-${uuidv4()}`);
      this.$emit('authorized');
    },
    validateEmail(email) {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    }
  }
}
</script>

<style scoped>
.auth-wrapper {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #d94a36 0%, #f77b0d 100%);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.auth-card {
  background: white;
  padding: 40px 30px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 400px;
  text-align: center;
  animation: fadeIn 0.5s ease-out;
}

.auth-card h1 {
  margin-bottom: 10px;
  font-size: 24px;
  color: #333;
}

.subtitle {
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
}

.subtitle img {
  max-width: 70%;
  height: auto;
  display: block;
  margin: 0 auto; /* центрируем */
}

.subtitle-text {
  margin-bottom: 15px;
  color: #666;
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
}

.auth-input {
  width: 90%;
  padding: 12px 14px;
  font-size: 16px;
  border: 2px solid #ccc;
  border-radius: 12px;
  transition: 0.3s;
  outline: none;
  margin-bottom: 16px;
}

.auth-input:focus {
  border-color: #d94a36;
  box-shadow: 0 0 5px #ffffff;
}

.button-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.auth-button {
  flex: 1;
  padding: 12px;
  background-color: #d94a36;
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}

.auth-button:hover {
  background-color: #f77b0d;
}

.skip-button {
  flex: 1;
  padding: 10px;
  background-color: #eee;
  border: none;
  border-radius: 12px;
  color: #555;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s;
}

.skip-button:hover {
  background-color: #ddd;
}

.error {
  margin-top: 15px;
  color: #e74c3c;
  font-size: 14px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user-auth.vue